<div class="remote-page">

  <div class="remote-header">
    <div class="remote-header-left">
      <h1>Remote</h1>
      <p class="subtitle">
        Address book for RustDesk clients - click Connect to launch a session.
      </p>
    </div>

    <div class="remote-header-right">
      <label for="remoteSearch">Search by</label>
      <input
        id="remoteSearch"
        type="search"
        class="remote-search"
        placeholder="Name or RustDesk ID"
        [(ngModel)]="searchTerm"
        (ngModelChange)="applySearch()"
      />

      <button
        type="button"
        class="btn btn-primary"
        (click)="onAddClient()"
      >
        + Add Client
      </button>
    </div>
  </div>

  <div class="remote-table-wrapper">
    <table class="remote-table">
      <thead>
        <tr>
          <th>Client</th>
          <th>RustDesk ID</th>
          <th>PIN / Password</th>
          <th>Contact</th>
          <th style="width: 140px;">Actions</th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngIf="groupedClients && groupedClients.length; else noClients">
          <ng-container *ngFor="let group of groupedClients">
            <tr class="group-row">
              <td colspan="5">
                <span class="group-title">{{ group.name }}</span>
              </td>
            </tr>

            <tr *ngFor="let client of group.clients">
              <td>
                <div class="client-main">
                  <span class="client-name">{{ client.name }}</span>
                </div>
              </td>

              <td>
                <div class="id-cell">
                  <span class="mono">{{ client.rustdeskId }}</span>
                  <button
                    type="button"
                    class="link-button"
                    title="Copy ID"
                    (click)="copyId(client.rustdeskId)">
                    Copy
                  </button>
                </div>
              </td>

              <td>
                <span class="mono">
                  {{ client.pin || '-' }}
                </span>
              </td>

              <td>
                <div class="contact-cell">
                  <div *ngIf="client.contactName">
                    {{ client.contactName }}
                  </div>
                  <div *ngIf="client.contactPhone" class="contact-secondary">
                    <span [apPhone]="client.contactPhone">{{client.contactPhone | phone}}</span>
                  </div>
                  <div *ngIf="client.contactEmail" class="contact-secondary">
                    {{ client.contactEmail }}
                  </div>
                </div>
              </td>

              <td>
                <div class="actions-cell">
                  <button
                    type="button"
                    class="btn btn-small btn-secondary"
                    (click)="onEditClient(client)"
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    class="btn btn-small btn-primary"
                    (click)="connect(client)"
                  >
                    Connect
                  </button>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-container>

        <ng-template #noClients>
          <tr>
            <td colspan="5" class="empty-state">
              No remote clients yet. Click <strong>Add Client</strong> to get started.
            </td>
          </tr>
        </ng-template>
      </tbody>
    </table>
  </div>
</div>
